import { contract as dashboardContract } from "@dashboard/contracts";
import { contract as physicalAddressContract } from "@physical-address/contracts";
import { contract as physicalStockContract } from "@physical-stock/contracts";
import { initContract } from "@ts-rest/core";
import {
  healthCheckContract,
  newDealRequestsContract,
  nominatedPurchaserContract,
  salePricesContract,
  saleProductContract,
} from "./contracts/index.js";

const c = initContract();

/**
 * The main contract for the Node app server which connects various domain specific contracts together
 */
export const appServerContract = c.router({
  ...healthCheckContract,
  ...salePricesContract,
  ...newDealRequestsContract,
  ...nominatedPurchaserContract,
  ...physicalStockContract,
  ...saleProductContract,
  ...dashboardContract,
  ...physicalAddressContract,
});
